package com.shadowings.gero.data.lessons.chapter15

import com.shadowings.gero.data.lessons.buildHieroQuizContent
import com.shadowings.gero.data.lessons.toHieroExplanation
import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_segni_vari_1
import gero.composeapp.generated.resources.exp_content_segni_vari_2
import gero.composeapp.generated.resources.exp_content_segni_vari_3
import gero.composeapp.generated.resources.exp_content_segni_vari_4
import gero.composeapp.generated.resources.exp_content_segni_vari_5
import gero.composeapp.generated.resources.exp_content_segni_vari_6
import gero.composeapp.generated.resources.exp_content_segni_vari_7
import gero.composeapp.generated.resources.exp_title_segni_vari

// New signs needed to write the words of NOMI_E_AGGETTIVI_1 (šmsw, ẖnw, ꜥꜣ, nḏs).
val segniVariHieroCodes = listOf("T18", "F26", "W24", "O29A", "I10", "G37")

// Already-taught signs, used only to pad the quiz to 10 questions and as
// extra pronunciation distractors - not re-taught here.
private val segniVariReviewHieroCodes = listOf(
    "U33", "N24", "N42", "U28", "D1", "V30", "R11", "N28", "D61",
    "G17", "N35", "Q3", "X1", "G43", "S29", "D36", "I9", "F35"
)

fun getSegniVariContent(
    hiero: List<Hiero>,
    languageCode: String
): List<IExplanation> {
    val intro = listOf(
        ExplanationContent(
            title = Res.string.exp_title_segni_vari,
            content = Res.string.exp_content_segni_vari_1,
            face = Faces.Perfect,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_segni_vari,
            content = Res.string.exp_content_segni_vari_2,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_segni_vari,
            content = Res.string.exp_content_segni_vari_3,
            face = Faces.Doubt,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_segni_vari,
            content = Res.string.exp_content_segni_vari_4,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_segni_vari,
            content = Res.string.exp_content_segni_vari_5,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_segni_vari,
            content = Res.string.exp_content_segni_vari_6,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_segni_vari,
            content = Res.string.exp_content_segni_vari_7,
            face = Faces.Perfect,
            character = Characters.Alyn,
        )
    )

    return intro + segniVariHieroCodes.toHieroExplanation(hiero, languageCode)
}

fun getSegniVariQuizContent(
    hiero: List<Hiero>,
    languageCode: String
): List<IQuizContent> {
    return buildHieroQuizContent(
        hiero = hiero,
        hieroContent = getSegniVariContent(hiero, languageCode),
        languageCode = languageCode,
        previousHieroContent = segniVariReviewHieroCodes.toHieroExplanation(hiero, languageCode)
    )
}
